export const environment = {
    prduction: false,
    apiKey: 'iaktech',   
};